import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="fullscreen-a"
            d="M13,3 L13,7 L12,7 L12,4 L9,4 L9,3 L13,3 Z M3,3 L7,3 L7,4 L4,4 L4,7 L3,7 L3,3 Z M13,13 L9,13 L9,12 L12,12 L12,9 L13,9 L13,13 Z M3,13 L3,9 L4,9 L4,12 L7,12 L7,13 L3,13 Z M0,1.99406028 C0,0.892771196 0.894513756,0 1.99406028,0 L14.0059397,0 C15.1072288,0 16,0.894513756 16,1.99406028 L16,14.0059397 C16,15.1072288 15.1054862,16 14.0059397,16 L1.99406028,16 C0.892771196,16 0,15.1054862 0,14.0059397 L0,1.99406028 Z M1,1.99406028 L1,14.0059397 C1,14.5539384 1.44579254,15 1.99406028,15 L14.0059397,15 C14.5539384,15 15,14.5542075 15,14.0059397 L15,1.99406028 C15,1.44606163 14.5542075,1 14.0059397,1 L1.99406028,1 C1.44606163,1 1,1.44579254 1,1.99406028 Z"/>
    </defs>
    <g fillRule="evenodd">
      <use xlinkHref="#fullscreen-a"/>
    </g>
  </svg>
);
